import { FC } from 'react';
import { IAlignedElement } from './AlignedElement.interfaces';

export const AlignedElement: FC<IAlignedElement> = (props) => {
  const { element, children, align = 'start' } = props;
  const attributes = props.attributes ?? {};

  return (
    <div
      style={{
        minHeight: '18px',
        textAlign: align,
      }}
      {...attributes}
      {...element.attr}
    >
      {children}
    </div>
  );
};
